export default function(Site, $) {
  Site.widget("sidebar-menu", {
    _create() {
      this.sidebarMenu();
    },
    sidebarMenu() {
      var hasChild = document.getElementsByClassName("page_item_has_children");

      for (var i = 0; i < hasChild.length; i++) {
        var newSpan = document.createElement("span");
        var newTrigger = document.createElement("div");
        newTrigger.classList.add("trigger");
        hasChild[i].appendChild(newSpan);
        hasChild[i].appendChild(newTrigger);
        // $(hasChild)
        //   .find("> a")
        //   .on("click", (e) => {
        //     e.preventDefault();
        //   });
      }

      this.element.find(".current_page_item").addClass("active");

      if (this.element.find(".current_page_ancestor").length) {
        this.element.find(".current_page_ancestor").addClass("active");
      }

      $(".page_item_has_children .trigger").click((e) => {
        $(e.currentTarget)
          .parent()
          .toggleClass("active");
      });
    },
  });
}
